// In-memory list of every public key generated or unlocked this tab, so
// the UI can show them all and let you click back to an earlier one.
// Just a display/selection registry - private key material stays in
// crypto.worker.ts, this module only ever sees public key hex strings.
export interface KnownKey {
  publicKeyHex: string;
  createdAt: number;
}

export const knownKeys: KnownKey[] = [];
export let activeKeyHex: string | null = null;

const listeners = new Set<() => void>();

export function onKeyRegistryChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify(): void {
  for (const listener of listeners) listener();
}

// Adds the key if it's new (re-unlocking an existing one is a no-op on
// the list) and makes it active either way.
export function rememberKey(publicKeyHex: string): void {
  if (!knownKeys.some((k) => k.publicKeyHex === publicKeyHex)) {
    knownKeys.push({ publicKeyHex, createdAt: Date.now() });
  }
  activeKeyHex = publicKeyHex;
  notify();
}

// Call only after the worker confirms it switched keys - don't update
// "active" here optimistically ahead of the worker.
export function setActiveKeyHex(publicKeyHex: string): void {
  activeKeyHex = publicKeyHex;
  notify();
}
